module.exports = __webpack_public_path__ + "img/gilberthall-v-474x632.167076a2.jpg";